
import React from "react";
import {createBrowserRouter, LoaderFunctionArgs, Outlet, redirect,} from "react-router";
import LoginPage from "../pages/LoginPage";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage";
import TermsPage from "../pages/TermsPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";

import ProfilePage from "../pages/ProfilePage";

import DashboardPage from "../pages/DashboardPage";
import DashboardHomePage from "../pages/DashboardHomePage";
import ReportsPage from "../pages/ReportsPage";
import HistoryListPage from "../timber/pages/history/HistoryListPage";
import UnauthorizedPage from "../pages/UnauthorizedPage";
import NotFoundPage from "../pages/NotFoundPage";
import ChangePasswordPage from '../pages/ChangePasswordPage';
import App from "./App";

import AddressListPage from "../address/pages/address/AddressListPage";
import AddressAddEditPage from "../address/pages/address/AddressAddEditPage";
import AddressUpdateEditPage from "../address/pages/address/AddressUpdateEditPage";
import AddressDetailPage from "../address/pages/address/AddressDetailPage";
import UserAddressListPage from "../address/pages/userAddress/UserAddressListPage";
import UserAddressAddEditPage from "../address/pages/userAddress/UserAddressAddEditPage";
import UserAddressUpdateEditPage from "../address/pages/userAddress/UserAddressUpdateEditPage";
import UserAddressDetailPage from "../address/pages/userAddress/UserAddressDetailPage";

import MembersGroupListPage from "../auth/pages/membersGroup/MembersGroupListPage";
import MembersGroupAddEditPage from "../auth/pages/membersGroup/MembersGroupAddEditPage";
import MembersGroupUpdateEditPage from "../auth/pages/membersGroup/MembersGroupUpdateEditPage";
import MembersGroupDetailPage from "../auth/pages/membersGroup/MembersGroupDetailPage";
import UserListPage from "../auth/pages/user/UserListPage";
import UserAddEditPage from "../auth/pages/user/UserAddEditPage";
import UserUpdateEditPage from "../auth/pages/user/UserUpdateEditPage";
import UserDetailPage from "../auth/pages/user/UserDetailPage";
import UserSessionListPage from "../auth/pages/userSession/UserSessionListPage";
import UserSessionAddEditPage from "../auth/pages/userSession/UserSessionAddEditPage";
import UserSessionUpdateEditPage from "../auth/pages/userSession/UserSessionUpdateEditPage";
import UserSessionDetailPage from "../auth/pages/userSession/UserSessionDetailPage";
import RoleListPage from "../auth/pages/role/RoleListPage";
import RoleAddEditPage from "../auth/pages/role/RoleAddEditPage";
import RoleUpdateEditPage from "../auth/pages/role/RoleUpdateEditPage";
import RoleDetailPage from "../auth/pages/role/RoleDetailPage";
import RolePermissionListPage from "../auth/pages/rolePermission/RolePermissionListPage";
import RolePermissionAddEditPage from "../auth/pages/rolePermission/RolePermissionAddEditPage";
import RolePermissionUpdateEditPage from "../auth/pages/rolePermission/RolePermissionUpdateEditPage";
import RolePermissionDetailPage from "../auth/pages/rolePermission/RolePermissionDetailPage";
import MembersGroupUserListPage from "../auth/pages/membersGroupUser/MembersGroupUserListPage";
import MembersGroupUserAddEditPage from "../auth/pages/membersGroupUser/MembersGroupUserAddEditPage";
import MembersGroupUserUpdateEditPage from "../auth/pages/membersGroupUser/MembersGroupUserUpdateEditPage";
import MembersGroupUserDetailPage from "../auth/pages/membersGroupUser/MembersGroupUserDetailPage";
import ScopeGroupListPage from "../auth/pages/scopeGroup/ScopeGroupListPage";
import ScopeGroupAddEditPage from "../auth/pages/scopeGroup/ScopeGroupAddEditPage";
import ScopeGroupUpdateEditPage from "../auth/pages/scopeGroup/ScopeGroupUpdateEditPage";
import ScopeGroupDetailPage from "../auth/pages/scopeGroup/ScopeGroupDetailPage";
import RoleAssignmentListPage from "../auth/pages/roleAssignment/RoleAssignmentListPage";
import RoleAssignmentAddEditPage from "../auth/pages/roleAssignment/RoleAssignmentAddEditPage";
import RoleAssignmentUpdateEditPage from "../auth/pages/roleAssignment/RoleAssignmentUpdateEditPage";
import RoleAssignmentDetailPage from "../auth/pages/roleAssignment/RoleAssignmentDetailPage";

import LocationListPage from "../location/pages/location/LocationListPage";
import LocationAddEditPage from "../location/pages/location/LocationAddEditPage";
import LocationUpdateEditPage from "../location/pages/location/LocationUpdateEditPage";
import LocationDetailPage from "../location/pages/location/LocationDetailPage";

import TimberClassListPage from "../timber/pages/timberClass/TimberClassListPage";
import TimberClassAddEditPage from "../timber/pages/timberClass/TimberClassAddEditPage";
import TimberClassUpdateEditPage from "../timber/pages/timberClass/TimberClassUpdateEditPage";
import TimberClassDetailPage from "../timber/pages/timberClass/TimberClassDetailPage";
import ThicknessClassListPage from "../timber/pages/thicknessClass/ThicknessClassListPage";
import ThicknessClassAddEditPage from "../timber/pages/thicknessClass/ThicknessClassAddEditPage";
import ThicknessClassUpdateEditPage from "../timber/pages/thicknessClass/ThicknessClassUpdateEditPage";
import ThicknessClassDetailPage from "../timber/pages/thicknessClass/ThicknessClassDetailPage";
import TimberTypeListPage from "../timber/pages/timberType/TimberTypeListPage";
import TimberTypeAddEditPage from "../timber/pages/timberType/TimberTypeAddEditPage";
import TimberTypeUpdateEditPage from "../timber/pages/timberType/TimberTypeUpdateEditPage";
import TimberTypeDetailPage from "../timber/pages/timberType/TimberTypeDetailPage";
import PricingProfileListPage from "../timber/pages/pricingProfile/PricingProfileListPage";
import PricingProfileAddEditPage from "../timber/pages/pricingProfile/PricingProfileAddEditPage";
import PricingProfileUpdateEditPage from "../timber/pages/pricingProfile/PricingProfileUpdateEditPage";
import PricingProfileDetailPage from "../timber/pages/pricingProfile/PricingProfileDetailPage";
import PriceListPage from "../timber/pages/price/PriceListPage";
import PriceAddEditPage from "../timber/pages/price/PriceAddEditPage";
import PriceUpdateEditPage from "../timber/pages/price/PriceUpdateEditPage";
import PriceDetailPage from "../timber/pages/price/PriceDetailPage";
import BuyerListPage from "../timber/pages/buyer/BuyerListPage";
import BuyerAddEditPage from "../timber/pages/buyer/BuyerAddEditPage";
import BuyerUpdateEditPage from "../timber/pages/buyer/BuyerUpdateEditPage";
import BuyerDetailPage from "../timber/pages/buyer/BuyerDetailPage";
import BuyerUserListPage from "../timber/pages/buyerUser/BuyerUserListPage";
import BuyerUserAddEditPage from "../timber/pages/buyerUser/BuyerUserAddEditPage";
import BuyerUserUpdateEditPage from "../timber/pages/buyerUser/BuyerUserUpdateEditPage";
import BuyerUserDetailPage from "../timber/pages/buyerUser/BuyerUserDetailPage";
import RoadCarrierListPage from "../timber/pages/roadCarrier/RoadCarrierListPage";
import RoadCarrierAddEditPage from "../timber/pages/roadCarrier/RoadCarrierAddEditPage";
import RoadCarrierUpdateEditPage from "../timber/pages/roadCarrier/RoadCarrierUpdateEditPage";
import RoadCarrierDetailPage from "../timber/pages/roadCarrier/RoadCarrierDetailPage";
import ContractorListPage from "../timber/pages/contractor/ContractorListPage";
import ContractorAddEditPage from "../timber/pages/contractor/ContractorAddEditPage";
import ContractorUpdateEditPage from "../timber/pages/contractor/ContractorUpdateEditPage";
import ContractorDetailPage from "../timber/pages/contractor/ContractorDetailPage";
import ContractorUserListPage from "../timber/pages/contractorUser/ContractorUserListPage";
import ContractorUserAddEditPage from "../timber/pages/contractorUser/ContractorUserAddEditPage";
import ContractorUserUpdateEditPage from "../timber/pages/contractorUser/ContractorUserUpdateEditPage";
import ContractorUserDetailPage from "../timber/pages/contractorUser/ContractorUserDetailPage";
import ForestOwnerListPage from "../timber/pages/forestOwner/ForestOwnerListPage";
import ForestOwnerAddEditPage from "../timber/pages/forestOwner/ForestOwnerAddEditPage";
import ForestOwnerUpdateEditPage from "../timber/pages/forestOwner/ForestOwnerUpdateEditPage";
import ForestOwnerDetailPage from "../timber/pages/forestOwner/ForestOwnerDetailPage";
import ProviderListPage from "../timber/pages/provider/ProviderListPage";
import ProviderAddEditPage from "../timber/pages/provider/ProviderAddEditPage";
import ProviderUpdateEditPage from "../timber/pages/provider/ProviderUpdateEditPage";
import ProviderDetailPage from "../timber/pages/provider/ProviderDetailPage";
import ProviderUserListPage from "../timber/pages/providerUser/ProviderUserListPage";
import ProviderUserAddEditPage from "../timber/pages/providerUser/ProviderUserAddEditPage";
import ProviderUserUpdateEditPage from "../timber/pages/providerUser/ProviderUserUpdateEditPage";
import ProviderUserDetailPage from "../timber/pages/providerUser/ProviderUserDetailPage";
import AccountingUserListPage from "../timber/pages/accountingUser/AccountingUserListPage";
import AccountingUserAddEditPage from "../timber/pages/accountingUser/AccountingUserAddEditPage";
import AccountingUserUpdateEditPage from "../timber/pages/accountingUser/AccountingUserUpdateEditPage";
import AccountingUserDetailPage from "../timber/pages/accountingUser/AccountingUserDetailPage";
import CuttingListPage from "../timber/pages/cutting/CuttingListPage";
import CuttingAddEditPage from "../timber/pages/cutting/CuttingAddEditPage";
import CuttingUpdateEditPage from "../timber/pages/cutting/CuttingUpdateEditPage";
import CuttingDetailPage from "../timber/pages/cutting/CuttingDetailPage";
import TimberStorageListPage from "../timber/pages/timberStorage/TimberStorageListPage";
import TimberStorageAddEditPage from "../timber/pages/timberStorage/TimberStorageAddEditPage";
import TimberStorageUpdateEditPage from "../timber/pages/timberStorage/TimberStorageUpdateEditPage";
import TimberStorageDetailPage from "../timber/pages/timberStorage/TimberStorageDetailPage";
import ShipmentListPage from "../timber/pages/shipment/ShipmentListPage";
import ShipmentAddEditPage from "../timber/pages/shipment/ShipmentAddEditPage";
import ShipmentUpdateEditPage from "../timber/pages/shipment/ShipmentUpdateEditPage";
import ShipmentDetailPage from "../timber/pages/shipment/ShipmentDetailPage";
import LogListPage from "../timber/pages/log/LogListPage";
import LogAddEditPage from "../timber/pages/log/LogAddEditPage";
import LogUpdateEditPage from "../timber/pages/log/LogUpdateEditPage";
import LogDetailPage from "../timber/pages/log/LogDetailPage";
import CordwoodListPage from "../timber/pages/cordwood/CordwoodListPage";
import CordwoodAddEditPage from "../timber/pages/cordwood/CordwoodAddEditPage";
import CordwoodUpdateEditPage from "../timber/pages/cordwood/CordwoodUpdateEditPage";
import CordwoodDetailPage from "../timber/pages/cordwood/CordwoodDetailPage";
import TreeMarkingListPage from "../timber/pages/treeMarking/TreeMarkingListPage";
import TreeMarkingAddEditPage from "../timber/pages/treeMarking/TreeMarkingAddEditPage";
import TreeMarkingUpdateEditPage from "../timber/pages/treeMarking/TreeMarkingUpdateEditPage";
import TreeMarkingDetailPage from "../timber/pages/treeMarking/TreeMarkingDetailPage";
import LogHistoryListPage from "../timber/pages/logHistory/LogHistoryListPage";
import LogHistoryAddEditPage from "../timber/pages/logHistory/LogHistoryAddEditPage";
import LogHistoryUpdateEditPage from "../timber/pages/logHistory/LogHistoryUpdateEditPage";
import LogHistoryDetailPage from "../timber/pages/logHistory/LogHistoryDetailPage";
import CordwoodHistoryListPage from "../timber/pages/cordwoodHistory/CordwoodHistoryListPage";
import CordwoodHistoryAddEditPage from "../timber/pages/cordwoodHistory/CordwoodHistoryAddEditPage";
import CordwoodHistoryUpdateEditPage from "../timber/pages/cordwoodHistory/CordwoodHistoryUpdateEditPage";
import CordwoodHistoryDetailPage from "../timber/pages/cordwoodHistory/CordwoodHistoryDetailPage";
import ShipmentHistoryListPage from "../timber/pages/shipmentHistory/ShipmentHistoryListPage";
import ShipmentHistoryAddEditPage from "../timber/pages/shipmentHistory/ShipmentHistoryAddEditPage";
import ShipmentHistoryUpdateEditPage from "../timber/pages/shipmentHistory/ShipmentHistoryUpdateEditPage";
import ShipmentHistoryDetailPage from "../timber/pages/shipmentHistory/ShipmentHistoryDetailPage";


import PreferencesPage from "../pages/PreferencesPage";

const Router = (store) => {

    function loginLoader() {

        
        
        
        return null;
    }

    function protectedLoader({ request }: LoaderFunctionArgs) {

        // If the user is not logged in and tries to access, we redirect
        // them to `/login` with a `from` parameter that allows login to redirect back
        // to this page upon successful authentication
        
        
        
        
        
        return null;
    }

    return createBrowserRouter(
        [
            {
                path: "/",
                element: <App/>,
                children: [
                    {
                        path: "401",
                        element: <UnauthorizedPage/>,
                    },
                    {
                        path: "404",
                        element: <NotFoundPage/>,
                    },
                    {
                        path: "", element: <DashboardPage/>,
                        children: [
                            {
                                index: true,
                                element: <DashboardHomePage/>
                            }
                        ]
                    },
                    {
                        path: "login", element: <LoginPage/>,
                        loader: loginLoader,
                    },
                    {
                        path: "privacy", element: <PrivacyPolicyPage/>,
                        loader: loginLoader,
                    },
                    {
                        path: "terms", element: <TermsPage/>,
                        loader: loginLoader,
                    },
                    {
                        path: "forgot-password", element: <ForgotPasswordPage/>,
                        loader: loginLoader,
                    },
                    {
                        path: "reset-password", element: <ResetPasswordPage/>,
                        loader: protectedLoader,
                    },
                    
                    {
                        path: "profile", element: <ProfilePage/>,
                        loader: protectedLoader,
                    },
                    {
                        path: "preferences", element: <PreferencesPage/>,
                        loader: protectedLoader,
                    },
                    {
                        path: "change-password", element: <ChangePasswordPage/>,
                        loader: protectedLoader,
                    },
                    {
                        path: "dashboard", element: <DashboardPage/>,
                        loader: protectedLoader,
                        children: [
                            {
                                index: true,
                                element: <DashboardHomePage/>
                            },
                            {
                                path: "reports",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ReportsPage/>,
                                    }
                                ],
                            },
                            {
                                path: "history",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <HistoryListPage/>,
                                    }
                                ],
                            },
                            
                            
                            
                            
                            
                            {
                                path: "members-groups",
                                
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <MembersGroupListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":membersGroupId",
                                        element: <MembersGroupDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":membersGroupId/edit",
                                        element: <MembersGroupUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <MembersGroupAddEditPage/>,
                                    },
                                    {
                                        path: ":membersGroupId/*",
                                        children: [
                                            
                                            
                                            
                            {
                                path: "users",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <UserListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":userId",
                                        element: <UserDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":userId/edit",
                                        element: <UserUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <UserAddEditPage/>,
                                    },
                                    {
                                        path: ":userId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "user-addresses",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <UserAddressListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":userAddressId",
                                        element: <UserAddressDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":userAddressId/edit",
                                        element: <UserAddressUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <UserAddressAddEditPage/>,
                                    },
                                    {
                                        path: ":userAddressId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "user-sessions",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <UserSessionListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":userSessionId",
                                        element: <UserSessionDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":userSessionId/edit",
                                        element: <UserSessionUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <UserSessionAddEditPage/>,
                                    },
                                    {
                                        path: ":userSessionId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "buyer-users",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <BuyerUserListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":buyerUserId",
                                        element: <BuyerUserDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":buyerUserId/edit",
                                        element: <BuyerUserUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <BuyerUserAddEditPage/>,
                                    },
                                    {
                                        path: ":buyerUserId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "members-group-users",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <MembersGroupUserListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":membersGroupUserId",
                                        element: <MembersGroupUserDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":membersGroupUserId/edit",
                                        element: <MembersGroupUserUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <MembersGroupUserAddEditPage/>,
                                    },
                                    {
                                        path: ":membersGroupUserId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "contractor-users",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ContractorUserListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":contractorUserId",
                                        element: <ContractorUserDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":contractorUserId/edit",
                                        element: <ContractorUserUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ContractorUserAddEditPage/>,
                                    },
                                    {
                                        path: ":contractorUserId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "shipments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId",
                                        element: <ShipmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId/edit",
                                        element: <ShipmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "shipment-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId",
                                        element: <ShipmentHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId/edit",
                                        element: <ShipmentHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "provider-users",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ProviderUserListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":providerUserId",
                                        element: <ProviderUserDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":providerUserId/edit",
                                        element: <ProviderUserUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ProviderUserAddEditPage/>,
                                    },
                                    {
                                        path: ":providerUserId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "accounting-users",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <AccountingUserListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":accountingUserId",
                                        element: <AccountingUserDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":accountingUserId/edit",
                                        element: <AccountingUserUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <AccountingUserAddEditPage/>,
                                    },
                                    {
                                        path: ":accountingUserId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                            {
                                path: "roles",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <RoleListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":roleId",
                                        element: <RoleDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":roleId/edit",
                                        element: <RoleUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <RoleAddEditPage/>,
                                    },
                                    {
                                        path: ":roleId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "role-permissions",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <RolePermissionListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":rolePermissionId",
                                        element: <RolePermissionDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":rolePermissionId/edit",
                                        element: <RolePermissionUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <RolePermissionAddEditPage/>,
                                    },
                                    {
                                        path: ":rolePermissionId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "role-assignments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <RoleAssignmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":roleAssignmentId",
                                        element: <RoleAssignmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":roleAssignmentId/edit",
                                        element: <RoleAssignmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <RoleAssignmentAddEditPage/>,
                                    },
                                    {
                                        path: ":roleAssignmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "members-group-users",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <MembersGroupUserListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":membersGroupUserId",
                                        element: <MembersGroupUserDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":membersGroupUserId/edit",
                                        element: <MembersGroupUserUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <MembersGroupUserAddEditPage/>,
                                    },
                                    {
                                        path: ":membersGroupUserId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "scope-groups",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ScopeGroupListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":scopeGroupId",
                                        element: <ScopeGroupDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":scopeGroupId/edit",
                                        element: <ScopeGroupUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ScopeGroupAddEditPage/>,
                                    },
                                    {
                                        path: ":scopeGroupId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "role-assignments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <RoleAssignmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":roleAssignmentId",
                                        element: <RoleAssignmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":roleAssignmentId/edit",
                                        element: <RoleAssignmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <RoleAssignmentAddEditPage/>,
                                    },
                                    {
                                        path: ":roleAssignmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "role-assignments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <RoleAssignmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":roleAssignmentId",
                                        element: <RoleAssignmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":roleAssignmentId/edit",
                                        element: <RoleAssignmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <RoleAssignmentAddEditPage/>,
                                    },
                                    {
                                        path: ":roleAssignmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                            
                            {
                                path: "users",
                                
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <UserListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":userId",
                                        element: <UserDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":userId/edit",
                                        element: <UserUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <UserAddEditPage/>,
                                    },
                                    {
                                        path: ":userId/*",
                                        children: [
                                            
                            {
                                path: "user-addresses",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <UserAddressListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":userAddressId",
                                        element: <UserAddressDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":userAddressId/edit",
                                        element: <UserAddressUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <UserAddressAddEditPage/>,
                                    },
                                    {
                                        path: ":userAddressId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "user-sessions",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <UserSessionListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":userSessionId",
                                        element: <UserSessionDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":userSessionId/edit",
                                        element: <UserSessionUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <UserSessionAddEditPage/>,
                                    },
                                    {
                                        path: ":userSessionId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "buyer-users",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <BuyerUserListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":buyerUserId",
                                        element: <BuyerUserDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":buyerUserId/edit",
                                        element: <BuyerUserUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <BuyerUserAddEditPage/>,
                                    },
                                    {
                                        path: ":buyerUserId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "members-group-users",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <MembersGroupUserListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":membersGroupUserId",
                                        element: <MembersGroupUserDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":membersGroupUserId/edit",
                                        element: <MembersGroupUserUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <MembersGroupUserAddEditPage/>,
                                    },
                                    {
                                        path: ":membersGroupUserId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "contractor-users",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ContractorUserListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":contractorUserId",
                                        element: <ContractorUserDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":contractorUserId/edit",
                                        element: <ContractorUserUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ContractorUserAddEditPage/>,
                                    },
                                    {
                                        path: ":contractorUserId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "shipments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId",
                                        element: <ShipmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId/edit",
                                        element: <ShipmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "shipment-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId",
                                        element: <ShipmentHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId/edit",
                                        element: <ShipmentHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "provider-users",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ProviderUserListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":providerUserId",
                                        element: <ProviderUserDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":providerUserId/edit",
                                        element: <ProviderUserUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ProviderUserAddEditPage/>,
                                    },
                                    {
                                        path: ":providerUserId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "accounting-users",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <AccountingUserListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":accountingUserId",
                                        element: <AccountingUserDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":accountingUserId/edit",
                                        element: <AccountingUserUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <AccountingUserAddEditPage/>,
                                    },
                                    {
                                        path: ":accountingUserId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                            
                            {
                                path: "roles",
                                
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <RoleListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":roleId",
                                        element: <RoleDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":roleId/edit",
                                        element: <RoleUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <RoleAddEditPage/>,
                                    },
                                    {
                                        path: ":roleId/*",
                                        children: [
                                            
                            {
                                path: "role-permissions",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <RolePermissionListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":rolePermissionId",
                                        element: <RolePermissionDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":rolePermissionId/edit",
                                        element: <RolePermissionUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <RolePermissionAddEditPage/>,
                                    },
                                    {
                                        path: ":rolePermissionId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "role-assignments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <RoleAssignmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":roleAssignmentId",
                                        element: <RoleAssignmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":roleAssignmentId/edit",
                                        element: <RoleAssignmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <RoleAssignmentAddEditPage/>,
                                    },
                                    {
                                        path: ":roleAssignmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                            
                            {
                                path: "scope-groups",
                                
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ScopeGroupListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":scopeGroupId",
                                        element: <ScopeGroupDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":scopeGroupId/edit",
                                        element: <ScopeGroupUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ScopeGroupAddEditPage/>,
                                    },
                                    {
                                        path: ":scopeGroupId/*",
                                        children: [
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "role-assignments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <RoleAssignmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":roleAssignmentId",
                                        element: <RoleAssignmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":roleAssignmentId/edit",
                                        element: <RoleAssignmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <RoleAssignmentAddEditPage/>,
                                    },
                                    {
                                        path: ":roleAssignmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                            
                            
                            {
                                path: "locations",
                                
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LocationListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":locationId",
                                        element: <LocationDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":locationId/edit",
                                        element: <LocationUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LocationAddEditPage/>,
                                    },
                                    {
                                        path: ":locationId/*",
                                        children: [
                                            
                                            
                                            
                                            
                            {
                                path: "timber-storages",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TimberStorageListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":timberStorageId",
                                        element: <TimberStorageDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":timberStorageId/edit",
                                        element: <TimberStorageUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TimberStorageAddEditPage/>,
                                    },
                                    {
                                        path: ":timberStorageId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "shipments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId",
                                        element: <ShipmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId/edit",
                                        element: <ShipmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "shipment-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId",
                                        element: <ShipmentHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId/edit",
                                        element: <ShipmentHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "tree-markings",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TreeMarkingListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId",
                                        element: <TreeMarkingDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId/edit",
                                        element: <TreeMarkingUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TreeMarkingAddEditPage/>,
                                    },
                                    {
                                        path: ":treeMarkingId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "shipments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId",
                                        element: <ShipmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId/edit",
                                        element: <ShipmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "shipment-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId",
                                        element: <ShipmentHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId/edit",
                                        element: <ShipmentHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                            
                            
                            {
                                path: "timber-classes",
                                
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TimberClassListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":timberClassId",
                                        element: <TimberClassDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":timberClassId/edit",
                                        element: <TimberClassUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TimberClassAddEditPage/>,
                                    },
                                    {
                                        path: ":timberClassId/*",
                                        children: [
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                            
                            {
                                path: "thickness-classes",
                                
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ThicknessClassListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":thicknessClassId",
                                        element: <ThicknessClassDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":thicknessClassId/edit",
                                        element: <ThicknessClassUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ThicknessClassAddEditPage/>,
                                    },
                                    {
                                        path: ":thicknessClassId/*",
                                        children: [
                                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                            
                            {
                                path: "timber-types",
                                
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TimberTypeListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":timberTypeId",
                                        element: <TimberTypeDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":timberTypeId/edit",
                                        element: <TimberTypeUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TimberTypeAddEditPage/>,
                                    },
                                    {
                                        path: ":timberTypeId/*",
                                        children: [
                                            
                                            
                                            
                                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                            
                            {
                                path: "pricing-profiles",
                                
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <PricingProfileListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":pricingProfileId",
                                        element: <PricingProfileDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":pricingProfileId/edit",
                                        element: <PricingProfileUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <PricingProfileAddEditPage/>,
                                    },
                                    {
                                        path: ":pricingProfileId/*",
                                        children: [
                                            
                            {
                                path: "prices",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <PriceListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":priceId",
                                        element: <PriceDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":priceId/edit",
                                        element: <PriceUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <PriceAddEditPage/>,
                                    },
                                    {
                                        path: ":priceId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                            
                            {
                                path: "buyers",
                                
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <BuyerListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":buyerId",
                                        element: <BuyerDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":buyerId/edit",
                                        element: <BuyerUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <BuyerAddEditPage/>,
                                    },
                                    {
                                        path: ":buyerId/*",
                                        children: [
                                            
                            {
                                path: "buyer-users",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <BuyerUserListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":buyerUserId",
                                        element: <BuyerUserDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":buyerUserId/edit",
                                        element: <BuyerUserUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <BuyerUserAddEditPage/>,
                                    },
                                    {
                                        path: ":buyerUserId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "shipments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId",
                                        element: <ShipmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId/edit",
                                        element: <ShipmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "shipment-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId",
                                        element: <ShipmentHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId/edit",
                                        element: <ShipmentHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                            
                            {
                                path: "road-carriers",
                                
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <RoadCarrierListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":roadCarrierId",
                                        element: <RoadCarrierDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":roadCarrierId/edit",
                                        element: <RoadCarrierUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <RoadCarrierAddEditPage/>,
                                    },
                                    {
                                        path: ":roadCarrierId/*",
                                        children: [
                                            
                            {
                                path: "shipments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId",
                                        element: <ShipmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId/edit",
                                        element: <ShipmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "shipment-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId",
                                        element: <ShipmentHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId/edit",
                                        element: <ShipmentHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                            
                            {
                                path: "contractors",
                                
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ContractorListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":contractorId",
                                        element: <ContractorDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":contractorId/edit",
                                        element: <ContractorUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ContractorAddEditPage/>,
                                    },
                                    {
                                        path: ":contractorId/*",
                                        children: [
                                            
                            {
                                path: "contractor-users",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ContractorUserListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":contractorUserId",
                                        element: <ContractorUserDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":contractorUserId/edit",
                                        element: <ContractorUserUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ContractorUserAddEditPage/>,
                                    },
                                    {
                                        path: ":contractorUserId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "shipments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId",
                                        element: <ShipmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId/edit",
                                        element: <ShipmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "shipment-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId",
                                        element: <ShipmentHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId/edit",
                                        element: <ShipmentHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cuttings",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CuttingListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cuttingId",
                                        element: <CuttingDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cuttingId/edit",
                                        element: <CuttingUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CuttingAddEditPage/>,
                                    },
                                    {
                                        path: ":cuttingId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "timber-storages",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TimberStorageListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":timberStorageId",
                                        element: <TimberStorageDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":timberStorageId/edit",
                                        element: <TimberStorageUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TimberStorageAddEditPage/>,
                                    },
                                    {
                                        path: ":timberStorageId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "shipments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId",
                                        element: <ShipmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId/edit",
                                        element: <ShipmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "shipment-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId",
                                        element: <ShipmentHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId/edit",
                                        element: <ShipmentHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "tree-markings",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TreeMarkingListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId",
                                        element: <TreeMarkingDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId/edit",
                                        element: <TreeMarkingUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TreeMarkingAddEditPage/>,
                                    },
                                    {
                                        path: ":treeMarkingId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "shipments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId",
                                        element: <ShipmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId/edit",
                                        element: <ShipmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "shipment-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId",
                                        element: <ShipmentHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId/edit",
                                        element: <ShipmentHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "tree-markings",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TreeMarkingListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId",
                                        element: <TreeMarkingDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId/edit",
                                        element: <TreeMarkingUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TreeMarkingAddEditPage/>,
                                    },
                                    {
                                        path: ":treeMarkingId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                            
                            {
                                path: "forest-owners",
                                
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ForestOwnerListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":forestOwnerId",
                                        element: <ForestOwnerDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":forestOwnerId/edit",
                                        element: <ForestOwnerUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ForestOwnerAddEditPage/>,
                                    },
                                    {
                                        path: ":forestOwnerId/*",
                                        children: [
                                            
                            {
                                path: "cuttings",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CuttingListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cuttingId",
                                        element: <CuttingDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cuttingId/edit",
                                        element: <CuttingUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CuttingAddEditPage/>,
                                    },
                                    {
                                        path: ":cuttingId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "timber-storages",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TimberStorageListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":timberStorageId",
                                        element: <TimberStorageDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":timberStorageId/edit",
                                        element: <TimberStorageUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TimberStorageAddEditPage/>,
                                    },
                                    {
                                        path: ":timberStorageId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "shipments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId",
                                        element: <ShipmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId/edit",
                                        element: <ShipmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "shipment-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId",
                                        element: <ShipmentHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId/edit",
                                        element: <ShipmentHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "tree-markings",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TreeMarkingListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId",
                                        element: <TreeMarkingDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId/edit",
                                        element: <TreeMarkingUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TreeMarkingAddEditPage/>,
                                    },
                                    {
                                        path: ":treeMarkingId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "shipments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId",
                                        element: <ShipmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId/edit",
                                        element: <ShipmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "shipment-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId",
                                        element: <ShipmentHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId/edit",
                                        element: <ShipmentHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "tree-markings",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TreeMarkingListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId",
                                        element: <TreeMarkingDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId/edit",
                                        element: <TreeMarkingUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TreeMarkingAddEditPage/>,
                                    },
                                    {
                                        path: ":treeMarkingId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "timber-storages",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TimberStorageListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":timberStorageId",
                                        element: <TimberStorageDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":timberStorageId/edit",
                                        element: <TimberStorageUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TimberStorageAddEditPage/>,
                                    },
                                    {
                                        path: ":timberStorageId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "shipments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId",
                                        element: <ShipmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId/edit",
                                        element: <ShipmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "shipment-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId",
                                        element: <ShipmentHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId/edit",
                                        element: <ShipmentHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "tree-markings",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TreeMarkingListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId",
                                        element: <TreeMarkingDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId/edit",
                                        element: <TreeMarkingUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TreeMarkingAddEditPage/>,
                                    },
                                    {
                                        path: ":treeMarkingId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                            
                            {
                                path: "providers",
                                
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ProviderListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":providerId",
                                        element: <ProviderDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":providerId/edit",
                                        element: <ProviderUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ProviderAddEditPage/>,
                                    },
                                    {
                                        path: ":providerId/*",
                                        children: [
                                            
                            {
                                path: "provider-users",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ProviderUserListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":providerUserId",
                                        element: <ProviderUserDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":providerUserId/edit",
                                        element: <ProviderUserUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ProviderUserAddEditPage/>,
                                    },
                                    {
                                        path: ":providerUserId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cuttings",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CuttingListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cuttingId",
                                        element: <CuttingDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cuttingId/edit",
                                        element: <CuttingUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CuttingAddEditPage/>,
                                    },
                                    {
                                        path: ":cuttingId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "timber-storages",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TimberStorageListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":timberStorageId",
                                        element: <TimberStorageDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":timberStorageId/edit",
                                        element: <TimberStorageUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TimberStorageAddEditPage/>,
                                    },
                                    {
                                        path: ":timberStorageId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "shipments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId",
                                        element: <ShipmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId/edit",
                                        element: <ShipmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "shipment-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId",
                                        element: <ShipmentHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId/edit",
                                        element: <ShipmentHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "tree-markings",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TreeMarkingListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId",
                                        element: <TreeMarkingDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId/edit",
                                        element: <TreeMarkingUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TreeMarkingAddEditPage/>,
                                    },
                                    {
                                        path: ":treeMarkingId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "shipments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId",
                                        element: <ShipmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId/edit",
                                        element: <ShipmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "shipment-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId",
                                        element: <ShipmentHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId/edit",
                                        element: <ShipmentHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "tree-markings",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TreeMarkingListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId",
                                        element: <TreeMarkingDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId/edit",
                                        element: <TreeMarkingUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TreeMarkingAddEditPage/>,
                                    },
                                    {
                                        path: ":treeMarkingId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                            
                            {
                                path: "accounting-users",
                                
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <AccountingUserListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":accountingUserId",
                                        element: <AccountingUserDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":accountingUserId/edit",
                                        element: <AccountingUserUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <AccountingUserAddEditPage/>,
                                    },
                                    {
                                        path: ":accountingUserId/*",
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                            
                            {
                                path: "cuttings",
                                
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CuttingListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cuttingId",
                                        element: <CuttingDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cuttingId/edit",
                                        element: <CuttingUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CuttingAddEditPage/>,
                                    },
                                    {
                                        path: ":cuttingId/*",
                                        children: [
                                            
                            {
                                path: "timber-storages",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TimberStorageListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":timberStorageId",
                                        element: <TimberStorageDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":timberStorageId/edit",
                                        element: <TimberStorageUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TimberStorageAddEditPage/>,
                                    },
                                    {
                                        path: ":timberStorageId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "shipments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId",
                                        element: <ShipmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId/edit",
                                        element: <ShipmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "shipment-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId",
                                        element: <ShipmentHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId/edit",
                                        element: <ShipmentHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "tree-markings",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TreeMarkingListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId",
                                        element: <TreeMarkingDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId/edit",
                                        element: <TreeMarkingUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TreeMarkingAddEditPage/>,
                                    },
                                    {
                                        path: ":treeMarkingId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "shipments",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId",
                                        element: <ShipmentDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentId/edit",
                                        element: <ShipmentUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                            {
                                path: "shipment-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <ShipmentHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId",
                                        element: <ShipmentHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":shipmentHistoryId/edit",
                                        element: <ShipmentHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <ShipmentHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":shipmentHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "logs",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId",
                                        element: <LogDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logId/edit",
                                        element: <LogUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogAddEditPage/>,
                                    },
                                    {
                                        path: ":logId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "log-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <LogHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId",
                                        element: <LogHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":logHistoryId/edit",
                                        element: <LogHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <LogHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":logHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "cordwoods",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId",
                                        element: <CordwoodDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodId/edit",
                                        element: <CordwoodUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                            {
                                path: "cordwood-histories",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <CordwoodHistoryListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId",
                                        element: <CordwoodHistoryDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":cordwoodHistoryId/edit",
                                        element: <CordwoodHistoryUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <CordwoodHistoryAddEditPage/>,
                                    },
                                    {
                                        path: ":cordwoodHistoryId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                            {
                                path: "tree-markings",
                                children: [
                                    {
                                        index: true,
                                        path: "",
                                        element: <TreeMarkingListPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId",
                                        element: <TreeMarkingDetailPage/>,
                                    },
                                    {
                                        index: true,
                                        path: ":treeMarkingId/edit",
                                        element: <TreeMarkingUpdateEditPage/>,
                                    },
                                    {
                                        index: true,
                                        path: "add",
                                        element: <TreeMarkingAddEditPage/>,
                                    },
                                    {
                                        path: ":treeMarkingId/*",
                                        element: <Outlet/>,
                                        children: [
                                            
                                        ]
                                    },
                                ]
                            },
                            
                                            
                                            
                                            
                                            
                                            
                                            
                                        ]
                                    },
                                ]
                            },
                            
                            
                            
                        ]
                    },
                ]
            }
        ],
        {basename: "/"}
    )
}

export default Router;
